import { notifyError } from './notify';

export default (error) => {
  if (error.name === 'CanceledError') {
    return;
  }

  if (error.response?.data) {
    if (error.response.data.data?.params) {
      Object.values(error.response.data.data.params).forEach((message) => {
        notifyError(message);
      });
    } else {
      notifyError(error.response.data?.message || 'Unknown error');
    }
  } else if (error.request?.data) {
    notifyError(error.request || 'Unknown error');
  } else {
    notifyError(error.message || 'Unknown error');
  }

  console.error(error);
};
